import { Create } from "react-admin";
import { PromoForm } from "./Form";

export function PromoCreate() {
  return (
    <Create redirect="list">
      <PromoForm />
    </Create>
  );
}
